module.exports = __webpack_public_path__ + "img/20170319-8.ff9da3a4.jpeg";